import { action, makeObservable, observable } from 'mobx';

import { OpenStore } from '../OpenStore';

export type PopupStoreOptions<Entity = null> = {
  entity?: Entity | null;
  isOpen?: boolean;
};

export class PopupStore<Entity = null> extends OpenStore {
  entity: Entity | null;

  constructor(options?: PopupStoreOptions<Entity>) {
    super(options?.isOpen ?? false);
    this.entity = options?.entity ?? null;

    makeObservable(this, {
      entity: observable.ref,
      openWithNull: action.bound,
    });
  }

  open(entity: Entity | null = null) {
    this.entity = entity;
    super.open();
  }

  openWithNull() {
    this.open(null);
  }

  close() {
    super.close();
  }
}
